import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { AdmitCardBody } from './AdmitCard';

export default function AdmitCardPrint() {
  const [cards, setCards] = useState([]);
  const [perPage, setPerPage] = useState(4);

  useEffect(() => {
    api.get('/cases/admit-cards').then((r) => setCards(r.data)).catch(() => setCards([]));
  }, []);

  return (
    <div data-testid="admit-print-page">
      <div className="mb-4 flex flex-wrap items-center gap-3 print:hidden">
        <h1 className="font-heading text-xl font-bold text-[#172033]">Print Admit Cards</h1>
        <span className="text-sm text-[#64748B]">{cards.length} scheduled</span>
        <div className="ml-auto flex items-center gap-2">
          <span className="text-xs font-semibold text-[#475569]">Cards per A4:</span>
          {[4, 6].map((n) => (
            <button key={n} data-testid={`perpage-${n}`} onClick={() => setPerPage(n)}
              className={`rounded-lg px-3 py-1.5 text-xs font-semibold ${perPage === n ? 'bg-navy text-white' : 'border border-[#E2E8F0] text-[#475569]'}`}>{n} per A4</button>
          ))}
          <button data-testid="do-print" onClick={() => window.print()} className="rounded-lg bg-action px-4 py-1.5 text-xs font-semibold text-white">Print</button>
        </div>
      </div>
      {cards.length === 0 ? (
        <p className="text-sm text-[#94A3B8] print:hidden">No scheduled admission tests to print.</p>
      ) : (
        <div className={`admit-sheet admit-grid-${perPage}`}>
          {cards.map((d) => (
            <div key={d.case_number} className="admit-cell">
              <AdmitCardBody d={d} compact />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
